import { useCommonStore } from '@shared/model'
import { runApiWrite } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'

/** `POST /admin-api/orders/{order}/retry` — charge a failed subscription order again. */
export const useOrderRetry = async (orderId: number): Promise<boolean> => {
  const commonStore = useCommonStore()

  return runApiWrite(useAdminRoutes('admin.order.retry', { order_id: orderId }), {
    setLoading: commonStore.setLoading,
  })
}
